function DashboardActiveMainCarControls({value}) {
    return (
        <div className="space-y-4">
            <h2 className="text-xs font-bold uppercase text-[#92adc9] tracking-wider">Car Controls</h2>
            <div className="space-y-3">
                <div>
                    <div className="flex justify-between text-[10px] font-bold mb-1">
                        <span className="uppercase">TC (Traction Control)</span>
                        <span className="text-acc-cyan">LEVEL {value.tc}</span>
                    </div>
                    <div className="flex gap-1 h-2">
                        {Array.from({ length: 10 }).map((_, index) => (
                            <div
                                key={index}
                                className={`flex-1 rounded-sm ${
                                index < value.tc ? "bg-acc-cyan" : "bg-[#233648]"
                                }`}
                            ></div>
                        ))}
                    </div>
                </div>
                <div>
                    <div className="flex justify-between text-[10px] font-bold mb-1">
                        <span className="uppercase">ABS (Anti-Lock Braking)</span>
                        <span className="text-acc-cyan">LEVEL {value.abs}</span>
                    </div>
                    <div className="flex gap-1 h-2">
                        {Array.from({ length: 10 }).map((_, index) => (
                            <div
                                key={index}
                                className={`flex-1 rounded-sm ${
                                index < value.abs ? "bg-acc-cyan" : "bg-[#233648]"
                                }`}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="pt-2">
                <span className="text-[10px] font-bold uppercase text-[#92adc9]">Steering Angle</span>
                <div className="mt-4 flex flex-col justify-center items-center relative h-10 w-full">
                    <div className="absolute left-0 right-0 h-px bg-[#324d67]"></div>
                    <div className="absolute top-0 -ml-px h-full w-0.5 bg-acc-red/50"></div>
                    <div className="absolute transition-[transform] duration-50 linear" style={{transform: `translate(${Math.floor(value.steer*138)}px, 1.5px)`}}>
                        <span className="material-symbols-outlined text-acc-cyan text-xl">stat_0</span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 flex justify-between text-[8px] text-[#92adc9] uppercase font-bold">
                        <span>-180°</span>
                        <span>0°</span>
                        <span>+180°</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveMainCarControls;